import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  effect,
  input,
  InputSignal,
  OnDestroy,
  output,
  OutputEmitterRef,
} from '@angular/core';
import { StickerData } from '../../services/sticker-list-controller/sticker-list-controller';
import { CanvasControllerService } from '../../../../../../services/canvas-controller/canvas-controller.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { StickerListControllerService } from '../../services/sticker-list-controller/sticker-list-controller.service';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'livery-attach-tool',
  imports: [CommonModule, FormsModule, MatSlideToggleModule, MatTooltipModule],
  templateUrl: './livery-attach-tool.component.html',
  styleUrl: './livery-attach-tool.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LiveryAttachToolComponent implements OnDestroy {
  public width: InputSignal<number> = input<number>(150);
  public attachSticker: InputSignal<StickerData | undefined> = input<StickerData | undefined>();
  public endAttach: OutputEmitterRef<boolean> = output<boolean>();

  public isDepthTool: boolean = false;
  public isCameraLocked: boolean = false;

  public cameraControlList: Array<'left' | 'right' | 'top' | 'front' | 'back'> = [
    'left',
    'right',
    'top',
    'front',
    'back',
  ];
  public cameraContolIndex: number = 0;

  public stickerData: StickerData = {
    title: '',
    type: 'sticker',
    image: '',
    thumnail: '',
  };

  public stickerTitle: string = '';
  public scale: number = 1;
  public rotate: number = 0;
  public depth: number = 5;

  public dualsideOption: boolean = false;

  constructor(
    private canvasController: CanvasControllerService,
    private stickerListController: StickerListControllerService,

    private cd: ChangeDetectorRef,
  ) {
    this.getEffect();
  }

  ngOnDestroy(): void {
    this.cameraContolIndex = 0;
    this.canvasController.cancelStickerView();
  }

  //---------------------------------------------------------------------------------
  // Public methods
  //---------------------------------------------------------------------------------

  public onClickCameraControl(index: number): void {
    this.cameraContolIndex = index;
    this.canvasController.changeCameraViewPosition(this.cameraControlList[index]);
    this.cd.markForCheck();
  }

  public onClickAttach(): void {
    if (!this.stickerData) return;
    this.cameraContolIndex = 0;
    this.canvasController.lockCamera(false);
    const timer = setTimeout(() => {
      this.canvasController.attachSticker(this.stickerData, this.dualsideOption);
      clearTimeout(timer);
    }, 150);
    if (this.dualsideOption) this.endAttach.emit(true);
    else this.isDepthTool = true;
    this.depth = this.canvasController.canvas?.depth ?? 5;
    this.isCameraLocked = false;
    this.cd.markForCheck();
  }

  public onClickCancel(): void {
    this.isDepthTool = false;
    this.cameraContolIndex = 0;
    this.canvasController.cancelStickerView();
    this.canvasController.lockCamera(false);
    this.isCameraLocked = false;
    this.endAttach.emit(true);
  }

  public changeScale(scale?: number): void {
    if (scale) this.scale = scale < 0.1 ? 0.1 : scale > 10 ? 10 : scale;
    this.canvasController.channgeScaleStickerView(this.scale);
    this.cd.markForCheck();
  }

  public changeRotate(rotate?: number): void {
    if (rotate) this.rotate = rotate < -360 ? 0 : rotate > 360 ? 360 : rotate;
    this.canvasController.channgeRotateStickerView(this.rotate);
    this.cd.markForCheck();
  }

  public changeDepth(depth?: number): void {
    if (depth) this.depth = depth < 0 ? 0 : depth > 10 ? 10 : depth;
    this.canvasController.changeStickerDeth(
      this.stickerListController.stickerMeshes[
        this.stickerListController.attachStickers.length - 1
      ],
      this.depth,
    );
    this.cd.markForCheck();
  }

  public onChangeCameraLocked(): void {
    this.canvasController.lockCamera(this.isCameraLocked);
  }

  //---------------------------------------------------------------------------------
  // Private methods
  //---------------------------------------------------------------------------------

  private getEffect(): void {
    effect(() => {
      const sticker = this.attachSticker();
      if (!sticker) return;
      this.stickerData = {
        title: sticker.title,
        type: sticker.type,
        image: sticker.image,
        thumnail: sticker.thumnail,
      };
      if (this.stickerData) {
        this.stickerTitle = this.stickerData.title;
        this.scale = this.stickerData.type == 'sticker' ? 1 : 3;
        this.rotate = 0;
        this.dualsideOption = this.stickerData.type == 'livery';
        this.cd.markForCheck();
      }
    });
  }
}
